import React from "react";
import { useApi } from "../../../hooks/useApi";

const fmtDate = (d) => {
  const dt = new Date(d);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
};

export function useGraphicalAiAdoption(range, member) {
  const api = useApi();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const startKey = range?.start ? fmtDate(range.start) : null;
  const endKey = range?.end ? fmtDate(range.end) : null;

  React.useEffect(() => {
    if (!startKey || !endKey) return undefined;
    let alive = true;
    setLoading(true);
    const memberQ = member ? `&userId=${encodeURIComponent(member)}` : "";
    api.get(`/api/v1/classic-dashboard/ai-adoption?startDate=${startKey}&endDate=${endKey}${memberQ}`)
      .then((res) => {
        if (!alive) return;
        const payload = res.data?.data || null;
        setData(payload && payload.empty ? null : payload);
      })
      .catch(() => { if (alive) setData(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [api, startKey, endKey, member]);

  return { data, loading };
}
